module.exports = __webpack_public_path__ + "static/POD-CS-d1f2a2877cc3c3f1d3d2121e2db97ba6.jpg";